import { render, staticRenderFns } from "./AutobuyerToggleLabel.vue?vue&type=template&id=3e71e566&scoped=true&"
import script from "./AutobuyerToggleLabel.vue?vue&type=script&lang=js&"
export * from "./AutobuyerToggleLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71e566",
  null
  
)

export default component.exports